module.exports = __webpack_public_path__ + "media/images/header_icon_infor-4de777835ae4dc190f428a6809cd5bf3.png";